import { useFilters, useFiltersActions } from '@/stores'

export default function ActiveFiltersChip() {
  const filters = useFilters()
  const { clearFilters } = useFiltersActions()
  if (!filters || filters.length === 0) return null
  const noun = filters.length === 1 ? 'filter' : 'filters'
  return (
    <div className="border-b border-blue-3/50 bg-blue-1/60 text-[11px]">
      <div className="mx-auto flex w-full max-w-5xl items-center justify-between gap-2 px-6 py-1.5">
        <span className="text-blue-7">
          {filters.length} {noun} active on transaction table
        </span>
        <button
          type="button"
          onClick={() => clearFilters()}
          className="rounded px-2 py-0.5 font-medium text-blue-7 hover:bg-blue-2 focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring"
        >
          Clear
        </button>
      </div>
    </div>
  )
}
